var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "table",
      {
        staticClass: "table table-striped table-bordered default-table",
        class: _vm.tableClass,
        attrs: { tabindex: "0" }
      },
      [
        _c("thead", [
          _c(
            "tr",
            [
              _vm.showSelect
                ? _c("th", { attrs: { tabindex: "0", scope: "col" } }, [
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Select")])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.columns, function(column, columnIndex) {
                return _c(
                  "th",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showColumn(column),
                        expression: "showColumn( column )"
                      }
                    ],
                    key: "table_header_" + columnIndex,
                    class: _vm.headerClasses,
                    attrs: {
                      width: column.headMaxWidth || "auto",
                      tabindex: "0",
                      scope: "col"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(column.heading) + "\n\t\t\t\t\t"
                    ),
                    column.popover && column.popover !== ""
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-unstyled btn-fixed",
                            attrs: {
                              type: "button",
                              "data-container": "body",
                              "data-toggle": "popover",
                              "data-placement": "top",
                              title: column.heading,
                              "data-content": column.popover
                            }
                          },
                          [_c("i", { staticClass: "fa fa-question-circle" })]
                        )
                      : _vm._e()
                  ]
                )
              }),
              _vm._v(" "),
              _vm._t("actions", [
                _vm.showActions
                  ? _c("th", { staticClass: "action-header" }, [
                      _vm._v(_vm._s(_vm.actionsHeader))
                    ])
                  : _vm._e()
              ])
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("tbody", [_vm._t("data-row"), _vm._v(" "), _vm._t("append-list")], 2)
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }